import { ColumnDef } from "@tanstack/react-table";
import { AxiosError, AxiosResponse } from "axios";
import React, { useEffect, useState,useRef } from "react";
import DataTable2 from "shared/DataTable2";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion"
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { benefitTemplate, Datum } from "../../interface/BenefitTemplate";
import { BenefitTemplateAxiosInstance } from "../../Network/BenefitTemplateAxiosInstance";
import { Option } from "../../interface/Option";
import Listofmedicalcode from "../Shared/ListofIcdmedicalcode";
import ListOfActivityCustom from "../Shared/ListOfActivityCustom";
import ListOfActivityMedical from "../Shared/ListOfActivityMedical";  
import ListofMedicalGroup from "../Shared/ListofMedicalGroup";
import ListofCustomIcd from "../Shared/ListofcustemIcd";
import ListofActivityCode from "../Shared/ListOfActivityCode"
import ActivitySelector from "../Shared/ActivityType";
const BenefitTemplate: React.FC = () => {
   // Main data state
   const [items, setItems] = useState<benefitTemplate>({ result: [] });
 
   // Form states
   const [Name, setName] = useState<string>("");
   const [description, setDescription] = useState<string>("");
   const [relatedIcds, setRelatedIcds] = useState<Option[]>([]);
   const [relatedActivity, setRelatedActivity] = useState<Option[]>([]);
   const [relatedIcdMedicalGroups, setRelatedIcdMedicalGroups] = useState<Option[]>([]);
   const [relatedIcdCustomGroups, setRelatedIcdCustomGroups] = useState<Option[]>([]);
   const [relatedActivitiesCustomGroups, setRelatedActivitiesCustomGroups] = useState<Option[]>([]);
   const [relatedActivitiesMedicalGroups, setRelatedActivitiesMedicalGroups] = useState<Option[]>([]);
   const [ActivityType, setActivityType] = useState<string>("");
   const [IcdDescription, setIcdDescription] = useState<string>("");
   const [maxCoverageOp, setMaxCoverageOp] = useState<number>(0);
   const [isOp, setisOp] =useState<boolean>(false);
   const [maxCoverageIp, setMaxCoverageIp] = useState<number>(0);
   const [isIp, setisIp] =useState<boolean>(false);
   const [IsActive, setIsActive] =useState<boolean>(false);
   const [copay, setCopay] = useState<number>(0);
   const [maxCopay, setMaxCopay] = useState<number>(0);
    
 
       // UI control states
     const [clearIcdmedicalcode, setClearIcdMedicalcode] = useState(false);
     const [clearRelatedActivitiesCustomGroups, setClearRelatedActivitiesCustomGroups] = useState(false);
     const [clearRelatedActivitiesMedicalGroups, setClearRelatedActivitiesMedicalGroups] = useState(false);
     const [clearRelatedIcdMedicalGroups, setClearRelatedIcdMedicalGroups] = useState(false);
     const [clearRelatedIcdCustomGroups, setClearRelatedIcdCustomGroups] = useState(false);
     const [clearActivityCode, setClearActivityCode] = useState(false);
     const [activityTypeisValid, setActivityTypeIsValid] = useState<boolean>(true); 
     const [isDialogOpen, setIsDialogOpen] = useState(false);
     const [editIndex, setEditIndex] = useState<null | number>(null);
     const [selectedIcdOption, setSelectedIcdOption] = useState<string | null>(null);
     const [selectedActivityOption, setSelectedActivityOption] = useState<string | null>(null);
 
   // dialog for details
     const [selectedItem, setSelectedItem] = useState<Datum | null>(null);
     const dialogRef = useRef<HTMLDialogElement | null>(null);
 
 // Get token from localStorage
   const token = localStorage.getItem("token") || "";
 
   // Initialize toast
   const { toast } = useToast();
 
   // Fetch initial data on component mount
   useEffect(() => {
     fetchItems();
 }, []);
 
 // Clear form function
   const clear = () => {
     setName("");
     setMaxCoverageOp(0);
     setDescription(""); 
  setRelatedActivitiesCustomGroups([]);
  setRelatedIcds([]);
  setRelatedIcdMedicalGroups([]);
  setRelatedActivitiesMedicalGroups([]);
  setRelatedIcdCustomGroups([]);    
 setRelatedActivity([]);
 setisOp(false);
 setMaxCoverageIp(0);
 setisIp(false);
 setCopay(0);
 setMaxCopay(0);
 setIsActive(false);
 setSelectedActivityOption(null)
   setSelectedIcdOption(null)
 };
 
 // Dialog details control handlers
 const handleOpenDialog = (item: Datum) => {
   setSelectedItem(item);
   dialogRef.current?.showModal(); 
 };
 
 const handleCloseDialog = () => {
   dialogRef.current?.close(); 
   setSelectedItem(null);
 }; 
 
   // Dialog control handlers
   const handleAddClick = () => {
     setEditIndex(null);
     clear();
     setIsDialogOpen(true); }
 
   const handleEditClick = (item: Datum) => {
     handleEdit(item);
     setIsDialogOpen(true); }
 
  const handleRelatedIcdsChange = (selectedOptions: Option[]) => {
          console.log("selected:", selectedOptions);
          setRelatedIcds(selectedOptions);
        };
        const handleRelatedActivityChange = (selectedOptions: Option[]) => {
         console.log("selected:", selectedOptions);
         setRelatedActivity(selectedOptions);
       };
        const handleRelatedActivitiesCustomGroupsChange = (selectedOptions: Option[]) => {
         console.log("selected:", selectedOptions);
         setRelatedActivitiesCustomGroups(selectedOptions);
       };
       const handleRelatedIcdCustomGroupsChange = (selectedOptions: Option[]) => {
         console.log("selected:", selectedOptions);
         setRelatedIcdCustomGroups(selectedOptions);
       };
       const handleRelatedActivitiesMedicalGroupsChange = (selectedOptions: Option[]) => {
         console.log("selected:", selectedOptions);
         setRelatedActivitiesMedicalGroups(selectedOptions);
       };
       const handleRelatedIcdMedicalGroupsChange = (selectedOptions: Option[]) => {
         console.log("selected:", selectedOptions);
         setRelatedIcdMedicalGroups(selectedOptions);
       };
       const handleActivityTypeChange = (ActivityType: string) => {
         setActivityType(ActivityType); //Update the status of the selected activityType
       };
       
   // API Functions
   const fetchItems = async (): Promise<void> => {
     try {
       const response: AxiosResponse<{ success: boolean; result: Datum[] }> =
         await BenefitTemplateAxiosInstance.get("getBenefitTemplate");
       setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

       console.log(response.data.result);
     } catch (error) {
       console.error("Error fetching items:", error);
       toast({
         title: "Error",
         description: "Failed to fetch Benefit Template",
         variant: "destructive",
       });
     }
   };
 
   const addItem = async (): Promise<void> => {
     try {
       const ValuesRelatedIcds = relatedIcds.map((option) => option.value);
       const ValuesRelatedActivity = relatedActivity.map((option) => option.value);
       const ValuesRelatedActivitiesCustomGroups = relatedActivitiesCustomGroups.map((option) => option.value);
       const ValuesRelatedActivitiesMedicalGroups = relatedActivitiesMedicalGroups.map((option) => option.value);
       const ValuesRelatedIcdMedicalGroups = relatedIcdMedicalGroups.map((option) => option.value);
       const ValuesRelatedIcdCustomGroups = relatedIcdCustomGroups.map((option) => option.value);
 
 console.log(ValuesRelatedActivity);
       const newGroupArray = [
         {
           name: Name,
           description:description,
           related_icds:ValuesRelatedIcds,
           related_icd_medical_groups:ValuesRelatedIcdMedicalGroups,
           related_icd_custom_groups:ValuesRelatedIcdCustomGroups,
           related_activities:ValuesRelatedActivity,
           related_activities_medical_groups:ValuesRelatedActivitiesMedicalGroups,
           related_activities_custom_groups:ValuesRelatedActivitiesCustomGroups,
           max_coverage_op:maxCoverageOp,
           is_op:isOp,
           max_coverage_ip:maxCoverageIp,
           is_ip:isIp,
           is_active:IsActive,
           copay:copay,
           max_copay:maxCopay,
          
         
         }
     ];
   console.log("newGroupArray", newGroupArray);
       const payload = {
         data: newGroupArray,
         token,
       };
   
       const response = await BenefitTemplateAxiosInstance.post(
         "addNewBenefitTemplate",
         payload
       );
   
       if (response.data.success) {
         fetchItems();
         clear();
         setIsDialogOpen(false);
   
         toast({
           title: "Success",
           description: "New Benefit  Added Successfully.",
         });
       } else {
                 const errors = response.data.errors || [];
                 const errorMessages = errors.map((error: any) => error.error).join("\n"); 
             
                 toast({
                   title: "Error",
                   description: errorMessages || response.data.message || "Failed to add the group.",
                   variant: "destructive",
                 });
             
                 console.log(errors);
               }
             } catch (error: AxiosError | any) {
               toast({
                 title: "Error",
                 description:
                   error.response?.data?.error || "An unexpected error occurred.",
                 variant: "destructive",
               });
             }
   };
   
 
   const handleEdit = (item: Datum) => {
     setName(item.name);
     setDescription(item.description);
   const mapToOptions = (arr: (string | number)[]): Option[] =>
         arr.map((value) => ({
           value: value,
           label: value.toString(),
         }));
         setRelatedIcds(mapToOptions(item.related_icds));
         setRelatedActivity(mapToOptions(item.related_activities));
             //Convert or process Custom Icd Groups fields
   const CustomIcdGroupsData = Array.isArray(item.related_icd_custom_groups)
   ? item.related_icd_custom_groups.map((obj) =>
       typeof obj === "string" ? { id: 0, name: obj } : obj
     )
   : [];
   
   setRelatedIcdCustomGroups(
   CustomIcdGroupsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
   );
   //Convert or process medical_Icd_groups fields
   const MedicalIcdGroupsData = Array.isArray(item.related_icd_medical_groups)
   ? item.related_icd_medical_groups.map((obj) =>
       typeof obj === "string" ? { id: 0, name: obj } : obj
     )
   : [];
   
   setRelatedIcdMedicalGroups(
   MedicalIcdGroupsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
   );
         //Convert or process Custom Activity Groups fields
   const CustomActivityGroupsData = Array.isArray(item.related_activities_custom_groups)
   ? item.related_activities_custom_groups.map((obj) =>
       typeof obj === "string" ? { id: 0, name: obj } : obj
     )
   : [];
   
   setRelatedActivitiesCustomGroups(
   CustomActivityGroupsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
   );
   //Convert or process medical_Activity_groups fields
   const MedicalActivityGroupsData = Array.isArray(item.related_activities_medical_groups)
   ? item.related_activities_medical_groups.map((obj) =>
       typeof obj === "string" ? { id: 0, name: obj } : obj
     )
   : [];
   
   setRelatedActivitiesMedicalGroups(
   MedicalActivityGroupsData.map((obj) => ({
     value: obj.id,
     label: obj.name,
   }))
   );
 
   setMaxCoverageIp(item.max_coverage_ip);
   setMaxCoverageOp(item.max_coverage_op);
   setisIp(item.is_ip);
   setisOp(item.is_op);
   setCopay(item.copay);
   setIsActive(item.is_active);
   setMaxCopay(item.max_copay);
   setEditIndex(item.id);
   };
   
 const updateItem = async (id: string | number): Promise<void> => {
       const ValuesRelatedIcds = relatedIcds.map((option) => option.value);
       const ValuesRelatedActivity = relatedActivity.map((option) => option.value);
       const ValuesRelatedActivitiesCustomGroups = relatedActivitiesCustomGroups.map((option) => option.value);
       const ValuesRelatedActivitiesMedicalGroups = relatedActivitiesMedicalGroups.map((option) => option.value);
       const ValuesRelatedIcdMedicalGroups = relatedIcdMedicalGroups.map((option) => option.value);
       const ValuesRelatedIcdCustomGroups = relatedIcdCustomGroups.map((option) => option.value);
     try {
  
       const updatedItem = {
         data: {
         name: Name,
           description:description,
           related_icds:ValuesRelatedIcds,
           related_icd_medical_groups:ValuesRelatedIcdMedicalGroups,
           related_icd_custom_groups:ValuesRelatedIcdCustomGroups,
           related_activities:ValuesRelatedActivity,
           related_activities_medical_groups:ValuesRelatedActivitiesMedicalGroups,
           related_activities_custom_groups:ValuesRelatedActivitiesCustomGroups,
           max_coverage_op:maxCoverageOp,
           is_op:isOp,
           max_coverage_ip:maxCoverageIp,
           is_ip:isIp,
           is_active:IsActive,
           copay:copay,
           max_copay:maxCopay,
           id: id,
         },
         token: token,
       };
 
       const response = await BenefitTemplateAxiosInstance.put(
         `updateBenefitTemplate`,
         updatedItem
       );
 
       if (response.data.success) {
         fetchItems();
         clear();
         setIsDialogOpen(false);
         toast({
           title: "Success",
           description: "Benefit Template updated successfully.",
         });
       }
     } catch (error: AxiosError | any) {
       toast({
         title: "Error",
         description:
           error.response?.data?.error || "An unexpected error occurred.",
           variant: "destructive",
       });
     }
   };
 
   const removeItem = async (id: string | number): Promise<void> => {
     try {
       await BenefitTemplateAxiosInstance.delete(`deleteBenefitTemplate/${id}`, {
         data: { token: token },
       });
       fetchItems();
       toast({
         title: "Success",
         description: "Benefit Template  Deleted Successfully.",
       });
     } catch (error) {
       console.error("Error removing item:", error);
       toast({
         title: "Error",
         description: "Failed to delete Benefit Template ",
         variant: "destructive",
       });
     }
   };
 
   // Table Columns Configuration
   const toggleActiveStatus = async (item: Datum): Promise<void> => {
     try {
       const response = await BenefitTemplateAxiosInstance.put(`updateBenefitTemplate`, {
         data: {
           id: item.id,
           name: item.name,
           description: item.description,
           related_icds: Array.isArray(item.related_icds) ? item.related_icds : [],
           related_activities: Array.isArray(item.related_activities) ? item.related_activities.map((a: any) => a.id || a) : [],
           is_active: !item.is_active,
         },
         token,
       });

       if (response.data.success) {
         fetchItems();
         toast({
           title: "Success",
           description: `Status updated to ${!item.is_active ? "Active" : "Inactive"}.`,
         });
       } else {
         toast({
           title: "Error",
           description: response.data.error || "Failed to update status",
           variant: "destructive",
         });
       }
     } catch (error: any) {
       toast({
         title: "Error",
         description: error.response?.data?.error || "Failed to update status",
         variant: "destructive",
       });
     }
   };

   const columns: ColumnDef<Datum>[] = [
     {
              accessorKey: "id",
              header: ({ column }) => (
                <Button
                  variant="ghost"
                  onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                >
                  ID
                  {column.getIsSorted() === "asc" ? " ↑" : column.getIsSorted() === "desc" ? " ↓" : ""}
                </Button>
              ),
              cell: ({ row }) => {
                const item = row.original; //Retrieve the full item
                return (
                  <button onClick={() => handleOpenDialog(item)} className="id-button">
                    {item.id}
                  </button>
                );
              }},
     {
       accessorKey: "name",
       header: ({ column }) => (
         <Button
           variant="ghost"
           onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
         >
           Name
           {column.getIsSorted() === "asc"
             ? " ↑"
             : column.getIsSorted() === "desc"
             ? " ↓"
             : ""}
         </Button>
       ),
     }, 
     {
         accessorKey: "description",
         header: ({ column }) => (
           <Button
             variant="ghost"
             onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
           >
             Description
             {column.getIsSorted() === "asc"
               ? " ↑"
               : column.getIsSorted() === "desc"
               ? " ↓"
               : ""}
           </Button>
         ),
       },
       
       {
         accessorKey: "related_icds",
         header: ({ column }) => (
           <Button
             variant="ghost"
             onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
           >
  ICD
             {column.getIsSorted() === "asc"
               ? " ↑"
               : column.getIsSorted() === "desc"
               ? " ↓"
               : ""}
           </Button>
         ),
         cell: ({ row }) => {
           const RelatedICDS = row.getValue("related_icds") as string[];
           return Array.isArray( RelatedICDS) ?   RelatedICDS.join(", ") :   RelatedICDS;
         },
       },  
 
     
       {
         accessorKey: "related_activities",
         header: ({ column }) => (
           <Button
             variant="ghost"
             onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
           >
             Activities
             {column.getIsSorted() === "asc"
               ? " ↑"
               : column.getIsSorted() === "desc"
               ? " ↓"
               : ""}
           </Button>
         ),
         cell: ({ row }) => {
           const RelatedActivities = row.getValue("related_activities") as { name: string }[];
       
           if (Array.isArray(RelatedActivities)) {
             return RelatedActivities.map(group => group.name).join(", ");
           }
       
           return RelatedActivities || "No related groups";
         },
       },
       {
         accessorKey: "is_active",
         header: () => <div className="w-full text-center normal-case font-normal">Status</div>,
         cell: ({ row }) => {
           const item = row.original;
           return (
             <div className="w-full flex justify-center">
               <button
                 onClick={() => toggleActiveStatus(item)}
                 className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                   item.is_active ? "bg-green-500" : "bg-gray-300"
                 }`}
               >
                 <span
                   className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                     item.is_active ? "translate-x-6" : "translate-x-1"
                   }`}
                 />
               </button>
             </div>
           );
         },
       },
     ];

   return (
        <div className=" h5-container mx-auto p-8">
     <h5 className="mb-6 flex items-center gap-2" style={{fontWeight:"bolder" ,fontSize:"22px",  marginTop:"15px"}}>
     <span className="icon-container">
                     <i className="fa-solid fa-list"></i>
                 </span>
         Benefit Template</h5>
 
       <DataTable2
         columns={columns}
         data={items.result}
         searchColumns={["name"]}
         addButtonLabel="Add New Benefit Template" 
         showAddButton={true}
         onEdit={handleEdit}
         onDelete={removeItem}
         onAdd={handleAddClick}
         onEditClick={handleEditClick}
       />
       {Boolean(selectedItem) && (
   <dialog ref={dialogRef} className="custom-dialog" open>
     {selectedItem && (
       <div className="dialog-content">
         {/* top-dialog-close-icon */}
         <button className="dialog-close-icon" onClick={handleCloseDialog}>
           ×
         </button>
         {/* dialog-title */}
         <h2 className="dialog-title">
           <span>Details for ID:</span> {selectedItem.id}
         </h2>
    {/* Content */}
         <div className="dialog-grid">
           <div className="dialog-row two-col-row">
             <div className="dialog-item">
               <strong>Relation Name:</strong> <span>{selectedItem.name}</span>
             </div>
              <div className="dialog-item">
               <strong>Description:</strong> <span>{selectedItem.description}</span>
             </div>
           </div>   
           <div className="dialog-row three-col-row">
         
           <div className="dialog-item">
             <strong>Activity Code:</strong>
             <p>{selectedItem.related_activities.join(", ")}</p>
           </div>
            <div className="dialog-item">
             <strong>Medical Activity Groups:</strong>
             <p>{selectedItem.related_activities_medical_groups.map(n => n.name).join(", ")}</p>
           </div>
            <div className="dialog-item">
             <strong>Custom Activity Groups:</strong>
             <p>{selectedItem.related_activities_custom_groups.map(n => n.name).join(", ")}</p>
           </div>
          </div>
           <div className="dialog-row three-col-row">
                <div className="dialog-item">
             <strong>ICD Code:</strong>
             <p>{selectedItem.related_icds.join(", ")}</p>
           </div>
           <div className="dialog-item">
             <strong>Medical ICD Groups:</strong>
             <p>{selectedItem.related_icd_medical_groups.map(n => n.name).join(", ")}</p>
           </div>
           <div className="dialog-item">
             <strong>Custom ICD Groups:</strong>
             <p>{selectedItem.related_icd_custom_groups.map(n => n.name).join(", ")}</p>
           </div>
         </div>
         <div className="dialog-row two-col-row">
             <div className="dialog-item">
               <strong>Max Coverage OP:</strong> <span>{selectedItem.max_coverage_op}</span>
               <strong className="ml-6"> Is OP:</strong> <span>{String(selectedItem.is_op)}</span>
             </div>
            
             <div className="dialog-item">
               <strong>Max Coverage IP:</strong> <span>{selectedItem.max_coverage_ip}</span>
               <strong className="ml-6"> Is IP:</strong> <span>{String(selectedItem.is_ip)}</span>
             </div>
         
             </div>
              <div className="dialog-row two-col-row">
             <div className="dialog-item">
               <strong>Copay:</strong> <span>{selectedItem.copay}</span>
             </div>
              <div className="dialog-item">
               <strong>Max Copay:</strong> <span>{selectedItem.max_copay}</span>
             </div>
           </div> 
           
             <div className="dialog-row single-row">
             <div className="dialog-item">
               <strong>Is Active:</strong> <span>{selectedItem.is_active}</span>
             </div>
           </div> 
         </div>
         <button className="dialog-close-btn" onClick={handleCloseDialog}>Close</button>
       </div>
     )}
   </dialog>
 )}
       <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>
                    {editIndex === null
                      ? "Add Benefit Template"
                      : "Edit Benefit Template"}
                  </DialogTitle>
                  </DialogHeader>
                <div className="grid grid-cols-2 gap-4 mt-4">
            {/* First Column */}
            <div>
                     <div className="mb-4">
                        <Label className="m-2" >Relation Name:</Label>
                        <Input
                           value={Name}
                           onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter Relation Name"
                                  />
                        </div>
                         <div className="mb-4">
                                    <Label htmlFor="main_diagnoses"> Activity:</Label>
                                  
                                    <Select onValueChange={(value) => setSelectedActivityOption(value)}>
                                      <SelectTrigger className="w-full">
                                        <SelectValue placeholder="Select an option" />
                                      </SelectTrigger>
                                      <SelectContent>
                                        <SelectItem value="list_of_Activity_code">List of Activity Code</SelectItem>
                                        <SelectItem value="medical_Activity_groups">Medical Activity Groups</SelectItem>
                                        <SelectItem value="custom_Activity_groups">Custom Activity Groups</SelectItem>
                                      </SelectContent>
                                    </Select>
                                  
                                    {selectedActivityOption === "list_of_Activity_code" && (
                                      <div className="mt-2 mb-4">
                                        <Label htmlFor="activity_type"> Activity Type:</Label>
                                        <ActivitySelector
                                          onSelectActivity={handleActivityTypeChange}
                                          selectedActivityType={ActivityType}
                                        />
                                      </div>
                                    )}
                                  
                                    {selectedActivityOption === "list_of_Activity_code" && ActivityType && (
                                      <div className="mt-2">
                                                   <ListofActivityCode
                     onChange={handleRelatedActivityChange}
                     type={ActivityType}
                     defaultValue={relatedActivity}  
                     clear={clearActivityCode}
                     isValid={ activityTypeisValid}
                   />
                                      </div>
                                    )}
                                  
                                    {selectedActivityOption === "medical_Activity_groups" && (
                                      <div className="mt-2">
                                                   <ListOfActivityMedical
          onChange={handleRelatedActivitiesMedicalGroupsChange}
        defaultValue={relatedActivitiesMedicalGroups}  
          clear={clearRelatedActivitiesMedicalGroups}
        />
                                      </div>
                                    )}
                                  
                                    {selectedActivityOption === "custom_Activity_groups" && (
                                      <div className="mt-2">
                                                 <ListOfActivityCustom
          onChange={handleRelatedActivitiesCustomGroupsChange}
        defaultValue={relatedActivitiesCustomGroups}  
          clear={clearRelatedActivitiesCustomGroups}
        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="mb-4">
                          <Label>Max Coverage IP :</Label>
                                   <Input
                                      id="max_coverage_ip"
                                      value={maxCoverageIp} 
                                      onChange={(e) => setMaxCoverageIp(Number(e.target.value))}    
                                       placeholder="Enter Max Coverage IP"
                                    />
                        </div>
                
                        <div className="mb-4">
                          <Label>Max Coverage OP:</Label>
                                 <Input
                                      id="max_coverage_op"
                                      value={maxCoverageOp} 
                                      onChange={(e) => setMaxCoverageOp(Number(e.target.value))}    
                                       placeholder="Enter Max Coverage OP"
                                    />                         </div>
                
                        <div className="mb-4">
                          <Label> Copay:</Label>
                             <Input
                                      id="copay"
                                      value={copay} 
                                      onChange={(e) => setCopay(Number(e.target.value))}    
                                       placeholder="Enter Copay"
                                    />                         </div>
                                 </div>
 
 
            {/* Second Column */}
            <div>
             <div className="mb-4">
                        <Label className="m-2" >:</Label>
                        <Input
                           value={description}
                           onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter Description"
                                  />
                        </div>
            <div className="mb-2">
            <Label htmlFor="main_diagnoses">ICD:</Label>
           
            <Select onValueChange={(value) => setSelectedIcdOption(value)}>
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Select an option" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="list_of_icd">List of ICD</SelectItem>
                <SelectItem value="medical_icd_groups">Medical ICD Groups</SelectItem>
                <SelectItem value="custom_icd_groups">Custom ICD Groups</SelectItem>
              </SelectContent>
            </Select>
        {selectedIcdOption === "list_of_icd" && (
              <div className="mt-2">
                          <Listofmedicalcode
          onChange={handleRelatedIcdsChange}
          description={IcdDescription}
          defaultValue={relatedIcds}  
          clear={clearIcdmedicalcode}
        />
              </div>
            )}
            {selectedIcdOption === "medical_icd_groups" && (
              <div className="mt-2">
                              <ListofMedicalGroup
          onChange={handleRelatedIcdMedicalGroupsChange}
      
          defaultValue={relatedIcdMedicalGroups}  
          clear={clearRelatedIcdMedicalGroups}
        />
              </div>
            )}
            {selectedIcdOption === "custom_icd_groups" && (
              <div className="mt-2">
                      <ListofCustomIcd
          onChange={handleRelatedIcdCustomGroupsChange}
        defaultValue={relatedIcdCustomGroups}  
          clear={clearRelatedIcdCustomGroups}
        />
              </div>
            )}
          </div>
               <div className="mb-3 w-80">
                         <Accordion type="single" collapsible>
                   <AccordionItem value="item-1">
                     <AccordionTrigger>Is IP?</AccordionTrigger>
                     <AccordionContent>
                     <div>
                             <label>
                               <input
                                 type="radio"
                                 name="ip"
                                 value="true"
                                 checked={isIp === true}
                                 onChange={(e) => setisIp(e.target.value === "true")}
                               />{" "}
                               True
                             </label>
                             <label className="m-2">
                               <input
                                 type="radio"
                                 name="Providers"
                                 value="false"
                                 checked={isIp === false}
                                 onChange={(e) => setisIp(e.target.value === "true")}
                               />{" "}
                               False
                             </label>
                           </div>
                     </AccordionContent>
                   </AccordionItem>
                 </Accordion>
                        </div>
                         <div className="mb-3 w-80">
                         <Accordion type="single" collapsible>
                   <AccordionItem value="item-1">
                     <AccordionTrigger>Is OP:</AccordionTrigger>
                     <AccordionContent>
                     <div>
                             <label>
                               <input
                                 type="radio"
                                 name="op"
                                 value="true"
                                 checked={isOp === true}
                                 onChange={(e) => setisOp(e.target.value === "true")}
                               />{" "}
                               True
                             </label>
                             <label className="ml-4">
                               <input
                                 type="radio"
                                 name="op"
                                 value="false"
                                 checked={isOp === false}
                                 onChange={(e) => setisOp(e.target.value === "true")}
                               />{" "}
                               False
                             </label>
                           </div>
                     </AccordionContent>
                   </AccordionItem>
                 </Accordion>
                        
                         </div>
 
                        <div className="mb-4">
                          <Label>Max Copay:</Label>
                             <Input
                                      id="max_copay"
                                      value={maxCopay} 
                                      onChange={(e) => setMaxCopay(Number(e.target.value))}    
                                       placeholder="Enter Max Copay"
                                    />                         </div>
 
 
                     
                             
                               <div className="mb-3 w-80">
                                <Accordion type="single" collapsible>
                          <AccordionItem value="item-1">
                            <AccordionTrigger>Is Active:</AccordionTrigger>
                            <AccordionContent>
                            <div>
                                    <label>
                                      <input
                                        type="radio"
                                        name="isActive"
                                        value="true"
                                        checked={IsActive === true}
                                        onChange={(e) => setIsActive(e.target.value === "true")}
                                      />{" "}
                                      True
                                    </label>
                                    <label className="ml-4">
                                      <input
                                        type="radio"
                                        name="isActive"
                                        value="false"
                                        checked={IsActive === false}
                                        onChange={(e) => setIsActive(e.target.value === "true")}
                                      />{" "}
                                      False
                                    </label>
                                  </div>
                            </AccordionContent>
                          </AccordionItem>
                        </Accordion>
                               </div>
           </div>
       
          </div>
              <DialogFooter className="gap-2 m-4">
                  <Button
                    onClick={() => {
                      if (editIndex === null) {
                        addItem();
                      } else {
                        updateItem(editIndex);
                      }
                    }}
                    className="bg-blue-600 hover:bg-blue-700"
                  >
                    {editIndex === null ? "Add Relation " : "Update Relation "}
                  </Button>
                  <Button
                    variant="outline"
                   
                      onClick={(e) => { 
                        setEditIndex(null);
                         clear(); 
                        setIsDialogOpen(false);
                       }}
                  >
                    Cancel
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
 
       <Toaster />
     </div>
   );
 };

export default BenefitTemplate;